import React from 'react';
import * as css from './LecturerSticker.css';

interface LectureStickerProps {
    index?: number;
    expanded?: boolean;
}

function LectureSticker({index = 0, expanded = false}: LectureStickerProps) {
    const color = css.STICKER_COLORS[index % css.STICKER_COLORS.length];

    return (
        <css.container $color={color} $expanded={expanded}>
            <css.star>⭐</css.star>
        </css.container>
    );
}

export default LectureSticker;
